import { TextField, Checkbox } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';

import { IMultiSelect } from '../../models/moments-report/filter-multiSelect-allSelect';
import { useAppDispatch, useAppSelector } from '../../store';
import { setCheckboxValue, setCompanyListToReportFilter, setReportFilter } from '../../store/features/moments-reports/momentReportsSlice';

const MultiSelect = ({ limitTags, placeholder, selectAllLabel, noOptionsText, onChange, open }: IMultiSelect) => {
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [inputVal, setInputVal] = useState('');
    const { reportFilter, companyAllListWithLabelValue } = useAppSelector(state => state.momentReports);
    const dispatch = useAppDispatch();

    const isAllSelectedOptions = companyAllListWithLabelValue?.items?.length === selectedOptions?.length;

    const handleToggleOption = selectedOptions => setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);

    const checkSearchCompany = (list, keyword) => {
        for (let i = 0; i < list.length; i++) {
            if (list[i]?.label?.toLowerCase()?.includes(keyword.toLowerCase())) {
                return true;
            }
        }
        return false;
    };

    const isCheckSearch = checkSearchCompany(companyAllListWithLabelValue?.items, inputVal);
    const getOptionLabel = option => `${option.label}`;

    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(companyAllListWithLabelValue?.items);
        } else {
            handleClearOptions();
            dispatch(setCompanyListToReportFilter([]));
            dispatch(setCheckboxValue(''));
        }
    };

    //!in the screen shown like this akmed, Koçsistem...
    useEffect(() => {
        if (selectedOptions?.length > 0) {
            const selectedValue = selectedOptions?.map(item => item?.label);
            let checkboxValue_ = '';

            if (selectedValue.length === companyAllListWithLabelValue?.items?.length && companyAllListWithLabelValue?.items?.length !== 1) {
                checkboxValue_ = selectAllLabel + ', ';
            } else {
                const companyNameList = reportFilter?.companyNameList;
                if (companyAllListWithLabelValue?.items?.length === 1) {
                    //! tek şirketse
                    checkboxValue_ = companyAllListWithLabelValue?.items[0]?.label;
                } else {
                    checkboxValue_ = companyNameList.join(' , ') + ', ';
                }
            }
            setInputValue(checkboxValue_);
            dispatch(setCheckboxValue(checkboxValue_));
        } else {
            dispatch(setCheckboxValue(''));
        }
    }, [selectedOptions, reportFilter?.companyNameList]);

    // useEffect(() => {

    // }, []);

    //!in the first time set all company to selecetedOptions
    useEffect(() => {
        if (reportFilter?.companyIdList?.length > 0 && selectedOptions?.length === 0) {
            setSelectedOptions(reportFilter?.companyList);
        }
    }, []);

    const handleToggleSelectAll = () => {
        handleSelectAll && handleSelectAll(!isAllSelectedOptions);
    };

    //! handle autocomple events..
    const handleChange = (_, selectedOptions, reason) => {
        if (reason === 'select-option' || reason === 'remove-option') {
            if (selectedOptions?.find(option => option?.value === 'select-all')) {
                handleToggleSelectAll();
                let result = [];
                result = companyAllListWithLabelValue?.items?.filter(el => el.value !== 'select-all');
                return onChange(result);
            } else {
                handleToggleOption && handleToggleOption(selectedOptions);
                return onChange(selectedOptions);
            }
        } else if (reason === 'clear' && companyAllListWithLabelValue?.items?.length !== 1) {
            handleClearOptions && handleClearOptions();
            dispatch(setCheckboxValue(''));
            dispatch(
                setReportFilter({
                    ...reportFilter,
                    companyList: [],
                    companyIdList: [],
                }),
            );
        }
    };

    //! options section..
    const optionRenderer = (option, { selected }) => {
        const selectAllProps =
            option.value === 'select-all' //! To control the state of 'select-all' checkbox
                ? { checked: isAllSelectedOptions }
                : {};

        return (
            <>
                <Checkbox
                    className="checkbox-company"
                    icon={<CheckBoxOutlineBlankIcon className="checkbox-icon" fontSize="small" />}
                    checkedIcon={<CheckBoxIcon className="checkbox-outline" fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    {...selectAllProps}
                />
                {getOptionLabel(option)}
            </>
        );
    };

    //! input section..
    const inputRenderer = params => (
        <TextField
            {...params}
            id="texfield-company-01"
            value={inputVal}
            onChange={e => setInputVal(e.target.value)}
            className={selectedOptions?.length === 0 ? 'textfield-company f-add-padding' : 'textfield-company'}
            variant="outlined"
            placeholder={selectedOptions?.length === 0 ? placeholder : ' '}
        />
    );

    const getOptionSelected = (option, anotherOption) => option.value === anotherOption.value;
    const filter = createFilterOptions();

    //!control dropdwon..

    return (
        <Autocomplete
            disabled={companyAllListWithLabelValue?.items?.length === 1}
            open={open}
            className={selectedOptions?.length === 0 ? 'autocomplete-06 error' : 'autocomplete-06'}
            multiple
            popupIcon={
                <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.5 7L12 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            }
            renderTags={_ => <span className="renderTag-option">{',' + inputValue}</span>}
            size="small"
            limitTags={limitTags}
            options={companyAllListWithLabelValue?.items}
            value={selectedOptions}
            disableCloseOnSelect
            getOptionLabel={getOptionLabel}
            getOptionSelected={getOptionSelected}
            noOptionsText={noOptionsText}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                if (companyAllListWithLabelValue?.items?.length !== 1) {
                    if (params?.inputValue?.length === 0) {
                        return [{ label: selectAllLabel, value: 'select-all' }, ...filtered];
                    } else if (params?.inputValue?.length > 0 && isCheckSearch) {
                        return [{ label: selectAllLabel, value: 'select-all' }, ...filtered];
                    } else {
                        return [...filtered];
                    }
                } else {
                    //!one-company
                    return [...filtered];
                }
            }}
            onChange={handleChange}
            renderOption={optionRenderer}
            renderInput={inputRenderer}
            getOptionDisabled={option => {
                //!control has one comany
                if (companyAllListWithLabelValue?.items?.length === 1) {
                    return true;
                }

                return false;
            }}
        />
    );
};

export default MultiSelect;
